"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconLogo = exports.Logo = void 0;
var legacy_1 = require("./legacy");
Object.defineProperty(exports, "Logo", { enumerable: true, get: function () { return legacy_1.Legacy; } });
var icon_1 = require("./icon");
Object.defineProperty(exports, "IconLogo", { enumerable: true, get: function () { return icon_1.Icon; } });
